import React, { useCallback, useEffect, useState } from 'react';
import { Form, FormSchema, getElementByName } from '@jht/react-library';
import { newFacilityFormSchema } from './facility-form-schemas';
import { useMst } from '../../core/stores';
import { FacilitiesFormProps } from './FormTypes';
import { NewOrExistingFacility } from '../../models';

export const getPayloadFromFormState = formState => {
  const stateElement = getElementByName(formState.elements, 'state');
  const stateValue = stateElement ? stateElement.value : null;
  return {
    name: getElementByName(formState.elements, 'name').value as string,
    isActive: '1',
    street1: getElementByName(formState.elements, 'street1').value as string,
    street2: getElementByName(formState.elements, 'street2').value as string,
    city: getElementByName(formState.elements, 'city').value as string,
    countryId: Number(getElementByName(formState.elements, 'country').value) || null,
    stateId: stateValue ? Number(stateValue) : null,
    postalCode: getElementByName(formState.elements, 'postalCode').value as string,
  };
};

export const NewFacilityForm: React.FC<FacilitiesFormProps> = ({ facility, isOpen, onChange }) => {
  const { digitalOrdersStore } = useMst();
  const newFacilityForm = newFacilityFormSchema(
    facility || { isActive: '1' },
    digitalOrdersStore.countries,
    digitalOrdersStore.getStatesForSelectedCountry(facility.countryId),
    digitalOrdersStore.existingFacilityNames,
  );

  const handleNewFacilityFormChange = useCallback(
    formState => {
      const payload = getPayloadFromFormState(formState);
      onChange({ type: NewOrExistingFacility.NEW, ...payload }, formState.valid);
    },
    [onChange, digitalOrdersStore],
  );

  return (
    <Form schema={newFacilityForm} onChange={handleNewFacilityFormChange} onSubmit={() => {}}>
      <></>
    </Form>
  );
};
